import { signal } from '@preact/signals';
import type { LayerControllerProps } from '@ui/core/layer/Layer.types';
import { modalState } from '@ui/core/modal/renderer/state';
import type { Ref } from 'preact/hooks';

export const appLayerController = { current: null } as Ref<LayerControllerProps>;
export const isAppLayerActive = signal<boolean>(true);
export const appLayerName = 'layer-main';

modalState.subscribe((modals) => {
    if (modals.length) {
        appLayerController.current?.setStatus(false);
        isAppLayerActive.value = false;
    } else {
        appLayerController.current?.setStatus(true);
        isAppLayerActive.value = true;
    }
});
